import { render } from "./PanelTopDownPINCadastro.vue?vue&type=template&id=5164e741"
import script from "./PanelTopDownPINCadastro.vue?vue&type=script&lang=js"
export * from "./PanelTopDownPINCadastro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__